import React, { useState, forwardRef, useImperativeHandle } from 'react';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import { api } from '../../api/api';

const LogPedidoModal = forwardRef((props, ref) => {
    const [show, setShow] = useState(false);
    const [logs, setLogs] = useState([]);
    const [pedidoId, setPedidoId] = useState(null);
    const [filterDate, setFilterDate] = useState('');

    // Expõe a função OpenModal via ref
    useImperativeHandle(ref, () => ({
        OpenModal: async (id) => {
            setPedidoId(id);
            try {
                api.get(`/api/pedidos/log/${id}`, response => {
                    const logsFormatted = response.data.map(log => ({
                        ...log,
                        data_log: format(parseISO(log.data_log), 'dd/MM/yyyy HH:mm:ss')
                    }));
                    setLogs(logsFormatted);
                    setShow(true);
                })
            } catch (err) {
                console.error(err);
                alert('Erro ao buscar logs');
            }
        }
    }));

    // Filtra logs pelo campo data_log
    const filteredLogs = filterDate
        ? logs.filter(log => log.data_log.startsWith(filterDate))
        : logs;

    if (!show) return null;

    return (
        <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div className="modal-content" style={{ zIndex: '123123' }}>
                    <div className="modal-header">
                        <h5 className="modal-title">Logs do Pedido #{pedidoId}</h5>
                        <button type="button" className="btn-close" onClick={() => setShow(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label me-2">Filtrar por data:</label>
                            <input
                                type="date"
                                className="form-control d-inline-block w-auto"
                                value={filterDate}
                                onChange={(e) => setFilterDate(e.target.value)}
                            />
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th>Nome</th>
                                        <th>Campo</th>
                                        <th>Valor Antigo</th>
                                        <th>Valor Novo</th>
                                        <th>Data</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredLogs.length > 0 ? (
                                        filteredLogs.map((log, idx) => (
                                            <tr key={idx}>
                                                <td>{log.nome}</td>
                                                <td>{log.campo}</td>
                                                <td>{log.valor_antigo}</td>
                                                <td>{log.valor_novo}</td>
                                                <td>{log.data_log}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5} className="text-center">Nenhum log encontrado</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={() => setShow(false)}>Fechar</button>
                    </div>
                </div>
            </div>
            {show && <div className="modal-backdrop fade show"></div>}
        </div>
    );
});

export default LogPedidoModal;
